
import Base from './base'

export default {
  name: 'VsTableSelection',
  extends: Base,
  watch: {
    total() {
      this.selected = this.table.selected.has(this.row)
    }
  },
  data() {
    return {
      selected: false
    }
  },
  computed: {
    total() {
      return this.table.selectedSize
    }
  },
  methods: {
    onChange(value) {
      this.table.toggleRowSelection(this.row, value)
    }
  }
}
